import { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";

export default function PlanTab({ id }) {
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    endpoints.plan(id).then((r) => setPlan(r.data.plan));
    const t = setInterval(() => endpoints.plan(id).then((r) => setPlan(r.data.plan)), 4000);
    return () => clearInterval(t);
  }, [id]);

  if (!plan) return <div className="text-sm text-muted-foreground">Agent is still assembling the plan…</div>;

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-3 gap-3">
        <Info label="TARGET" value={plan.target} accent />
        <Info label="PROBLEM" value={plan.problem_type} />
        <Info label="METRIC" value={plan.primary_metric} />
      </div>

      <div>
        <div className="label-mono mb-4">// AGENT PLAN</div>
        <ol className="border-l border-border ml-2 space-y-6">
          {plan.steps.map((s, i) => (
            <li key={i} className="relative pl-6" data-testid={`plan-step-${i}`}>
              <div className="absolute -left-[7px] top-1 w-3 h-3 rounded-sm bg-accent" />
              <div className="font-display font-semibold text-base">
                <span className="label-mono mr-2">{String(i + 1).padStart(2, "0")}</span>
                {s.title}
              </div>
              <div className="text-sm text-muted-foreground mt-1 leading-relaxed">{s.detail}</div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}

function Info({ label, value, accent }) {
  return (
    <div className="border border-border p-4 rounded-sm bg-card">
      <div className="label-mono">{label}</div>
      <div className={`font-mono text-lg mt-1 ${accent ? "text-accent" : ""}`}>{value || "—"}</div>
    </div>
  );
}
